

const EventType = {
    Intervento: "Intervento",
    Assenza: "Assenza",
    RichiestaPermesso: "RichiestaPermesso",
  };

  export default EventType;